<template>
  <Block :title="dailyTitle" :subtitle="subtitle" :emoji="statusEmoji" :badge-class="statusClassBg" />
</template>

<script>
import { Block } from "@estaly/ui";

export default {
  components: {
    Block,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    target: {
      type: Number,
      required: true,
    },
    leadsWaiting: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    dailyTitle() {
      return `${this.current} / ${this.$t("roadmap.sales", this.target)} aujourd'hui`;
    },
    subtitle() {
      return this.leadsWaiting > 0
        ? `+${this.$t("roadmap.sales", this.leadsWaiting)} SEPA en attente`
        : "Performance d'aujourd'hui";
    },
    isCompleted() {
      return this.current >= this.target;
    },
    statusClassBg() {
      return this.isCompleted ? "bg-green-50" : "bg-yellow-50";
    },
    statusEmoji() {
      return this.isCompleted ? "👏" : "⚙️";
    },
  },
};
</script>
